<template>
  <div class="avatar-placeholder">
    <div v-html="identicon"></div>
  </div>
</template>

<script>
import jdenticon from 'jdenticon';

export default {
  props: {
    name: {
      type: String,
      required: true,
    },

    size: {
      type: Number,
      required: false,
      default: 128,
    },
  },

  computed: {
    identicon() {
      return jdenticon.toSvg(this.name, this.size);
    },
  },
};
</script>
